export default [
  { id: 1, name: 'میکروبی' },
  { id: 2, name: 'شیمیایی' },
  { id: 3, name: 'سلولزی' },
  { id: 4, name: 'بسته بندی' },
  { id: 5, name: 'محیط زیست' },
  { id: 6, name: 'جذب اتمی' },
  { id: 7, name: 'کروماتوگرافی گازی' },
  { id: 8, name: 'کروماتوگرافی مایع' },
  { id: 9, name: 'نساجی' },
  { id: 10, name: 'مهندسی پزشکی' },
  { id: 11, name: 'آرایشی بهداشتی' },
]

export const allTypeId = 0;
export const microbialTypeId = 1;
export const chemicalTypeId = 2;
export const celolluseTypeId = 3;
export const packingTypeId = 4;
export const environmentTypeId = 5;
export const atomiTypeId = 6;
export const gaziTypeId = 7;
export const mayeTypeId = 8;
export const nasajiTypeId = 9;
export const pezeshkiTypeId = 10;
export const behdashtiTypeId = 11;